import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import {ORDER_METHODS} from "../../../core/constants/payMethods-cr";

@Component({
  selector: 'app-return-methods',
  templateUrl: './return-methods.component.html',
  styleUrls: ['./return-methods.component.scss'],
})
export class ReturnMethodsComponent implements OnInit {

  @Input() unique: string;
  @Input() itsMobileCtrl: boolean;
  @Output() RT = new EventEmitter();
  method: boolean;

  constructor() {
  }

  ngOnInit() {
    this.setMobile(window.innerWidth);
    if (this.unique !== '' && this.unique !== ORDER_METHODS.BNCR && this.unique !== ORDER_METHODS.BCR) {
      this.method = false;
    }
  }

  funcDisableButton() {
    this.method = false;
  }

  funcEnableButton() {
    this.method = true;
  }

  changeMethod() {
    this.RT.emit();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    let width: number = event.target.innerWidth;
    if (this.unique == '')
      this.setMobile(width);
  }

  setMobile(width: number) {
    if (this.itsMobileCtrl)
      this.method = width < 768;
    else
      this.method = width > 768;
  }


}
